<template>
  <hr-form-dialog
    ref="dialog"
    size="sm"
    :title="title"
    @hide="onDialogHide"
  >
    <div class="row q-col-gutter-md">
      <p
        v-if="text"
        class="col-12 q-ma-none"
      >
        {{ text }}
      </p>
      <div class="col-12">
        <client-users-selector
          v-model="selectedUser"
          :label="label"
          :client="client"
          :skip-current-user="skipCurrentUser"
          :skip-roles="skipRoles"
          :skip-users="skipUsers"
        />
      </div>
    </div>
    <template #actions>
      <hr-dismiss-btn
        :label="$t('common.buttonCancel')"
        @click="onCancelClick"
      />
      <hr-confirm-btn
        :label="okButton"
        :disable="noSelectedUser"
        @click="onOKClick"
      />
    </template>
  </hr-form-dialog>
</template>
<script>
import ClientUsersSelector from 'components/UI/ClientUsersSelector';
import { isEmpty } from 'lodash';
import {
  HrConfirmBtn,
  HrDismissBtn,
  HrFormDialog,
} from 'src/design-system';

export default {
  name: 'SelectClientUser',

  components: {
    ClientUsersSelector,
    HrConfirmBtn,
    HrDismissBtn,
    HrFormDialog,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    okButton: {
      type: String,
      required: true,
    },
    client: {
      type: String,
      default: null,
    },
    skipRoles: {
      type: Array,
      default: () => ([]),
    },
    skipUsers: {
      type: Array,
      default: () => ([]),
    },
    label: {
      type: String,
      default: null,
    },
    skipCurrentUser: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['hide', 'ok'],

  data() {
    return {
      selectedUser: null,
    };
  },

  computed: {
    noSelectedUser() {
      return isEmpty(this.selectedUser);
    },
  },

  methods: {

    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      if (this.$refs.dialog) {
        this.$refs.dialog.hide();
      }
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    },

    async onOKClick() {
      this.$emit('ok', this.selectedUser);
      this.hide();
    },

    onCancelClick() {
      // we just need to hide dialog
      this.hide();
    },

  },

};
</script>
